function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { chain, forEach, join, split } from 'lodash';
import { AccesoDatos } from '../../../comun/services/acceso-datos';
import { SubPregunta } from './subpregunta';
var TarjetaPreguntaComponentCtrl = /*#__PURE__*/function () {
  TarjetaPreguntaComponentCtrl.$inject = ["$element", "$timeout", "$log", "NotifService", "AccesoDatos"];
  function TarjetaPreguntaComponentCtrl($element, $timeout, $log, NotifService, AccesoDatos) {
    _classCallCheck(this, TarjetaPreguntaComponentCtrl);
    _defineProperty(this, "dirty", false);
    _defineProperty(this, "editando", false);
    _defineProperty(this, "options", []);
    _defineProperty(this, "subpregs", []);
    _defineProperty(this, "usosData", {
      visible: false,
      leido: false,
      list: []
    });
    this.$element = $element;
    this.$timeout = $timeout;
    this.$log = $log;
    this.NotifService = NotifService;
    this.AccesoDatos = AccesoDatos;
  }
  return _createClass(TarjetaPreguntaComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[TarjetaPreguntaComponentCtrl] onInit');
      this._initPreg();
      if (!this.pregunta.datapreg.data.idquest) {
        // sin pregunta?
        this.editarPreg();
      }
    }
  }, {
    key: "_initPreg",
    value: function _initPreg() {
      // si es de tipo SELECT, hacer split de las opciones
      if (this.pregunta.datapreg.data && this.pregunta.datapreg.data.tipoq == 'SELECT') this.options = split(this.pregunta.datapreg.data.options, '|');

      // si es de tipo ROW, pintar las subpreguntas
      if (this.pregunta.datapreg.data && this.pregunta.datapreg.data.tipoq == 'ROW') this.subpregs = chain(this.pregunta.datapreg.subp).map(function (subp) {
        return new SubPregunta(subp);
      }).value();
      this.dirty = false;
    }
  }, {
    key: "$postLink",
    value: function $postLink() {
      // this.$timeout(() => (this.$element.find('select') as any).formSelect(), 10)
    }
  }, {
    key: "guardarPregunta",
    value: function guardarPregunta() {
      var _this = this;
      // generar las opciones del select
      if (this.pregunta.datapreg.data.tipoq == 'SELECT') {
        this.pregunta.datapreg.data.options = join(this.options, '|');
      }

      // si es de tipo ROW, preparar las subpreguntas
      if (this.pregunta.datapreg.data.tipoq == 'ROW') {
        this.pregunta.datapreg.subp = this._generaSubPregs();
      } else this.pregunta.datapreg.subp = [];
      this.AccesoDatos.Preg_CLIENT.nuevoPregunta(this.pregunta.datapreg).then(function (response) {
        _this.pregunta.datapreg = response;
        _this.dirty = false;
      });
    }
  }, {
    key: "editarPreg",
    value: function editarPreg() {
      var _this2 = this;
      this.editando = !this.editando;
      if (this.editando) {
        this.$timeout(function () {
          return _this2.$element.find('select').formSelect();
        }, 10);
        this.$timeout(function () {
          var textarea = _this2.$element.find('.materialize-textarea');
          if (textarea && textarea[0]) M.textareaAutoResize(textarea);
        }, 200);
      }
    }
  }, {
    key: "refreshPreg",
    value: function refreshPreg() {
      var _this3 = this;
      this.AccesoDatos.Preg_CLIENT.leerPregunta(this.pregunta.datapreg.data.idquest).then(function (response) {
        _this3.pregunta.datapreg = {
          data: response.data,
          subp: response.subp,
          f: null,
          eliminar: false
        };
        _this3._initPreg();
        _this3.editarPreg();
      });
    }
  }, {
    key: "cerrarUsosPreg",
    value: function cerrarUsosPreg() {
      this.usosData.visible = false;
    }
  }, {
    key: "usosPreg",
    value: function usosPreg() {
      var _this4 = this;
      this.AccesoDatos.Preg_CLIENT.usosPregunta(this.pregunta.datapreg.data.idquest).then(function (list) {
        _this4.usosData = {
          visible: true,
          leido: true,
          list: list
        };
      });
    }
  }, {
    key: "nuevaOpcion",
    value: function nuevaOpcion() {
      this.options.push('');
      this.dirty = true;
    }
  }, {
    key: "splitOpcion",
    value: function splitOpcion(idx) {
      this.options.splice(idx, 1);
      this.dirty = true;
    }
  }, {
    key: "splitOpcion_Subp",
    value: function splitOpcion_Subp($subp, $idx) {
      $subp.splitOpcion($idx);
      this.dirty = true;
    }
  }, {
    key: "nuevaOpcion_Subp",
    value: function nuevaOpcion_Subp($subp) {
      $subp.nuevaOpcion();
      this.dirty = true;
    }
  }, {
    key: "nuevaSubPreg",
    value: function nuevaSubPreg() {
      var _this5 = this;
      this.subpregs.push(new SubPregunta({
        data: {
          subpreg: true
        },
        subp: []
      }));
      this.$timeout(function () {
        return _this5.$element.find('select').formSelect();
      }, 1);
      this.dirty = true;
    }
  }, {
    key: "splitSubPreg",
    value: function splitSubPreg(idx) {
      var subp = this.subpregs.splice(idx, 1);

      // marcar la subpregunta para eliminar
      forEach(subp, function (p) {
        return p.paraEliminar();
      });
      this.dirty = true;
    }
  }, {
    key: "_generaSubPregs",
    value: function _generaSubPregs() {
      return chain(this.subpregs).map(function (p) {
        return p.paraGuardar();
      }).value();
    }
  }, {
    key: "quitarMainQ",
    value: function quitarMainQ() {
      this.pregunta.datapreg.data.mainq_id = null;
      this.dirty = true;
    }
  }, {
    key: "quitarMainQ_Subp",
    value: function quitarMainQ_Subp($subp) {
      $subp.p.data.mainq_id = null;
      this.dirty = true;
    }
  }, {
    key: "marcaListado",
    value: function marcaListado(idx) {
      var subp = this.subpregs[idx];
      subp.p.data.listado = !subp.p.data.listado;
      this.dirty = true;
    }
  }, {
    key: "marcaExport",
    value: function marcaExport(idx) {
      var subp = this.subpregs[idx];
      subp.p.data.exportar = !subp.p.data.exportar;
      this.dirty = true;
    }
  }, {
    key: "marcaRequired",
    value: function marcaRequired(idx) {
      var subp = this.subpregs[idx];
      subp.p.data.required = !subp.p.data.required;
      this.dirty = true;
    }
  }, {
    key: "marcaBuscar",
    value: function marcaBuscar(idx) {
      var subp = this.subpregs[idx];
      subp.p.data.buscar = !subp.p.data.buscar;
      this.dirty = true;
    }
  }, {
    key: "marcaKeepHistory",
    value: function marcaKeepHistory(idx) {
      var subp = this.subpregs[idx];
      subp.p.data.keep_history = !subp.p.data.keep_history;
      this.dirty = true;
    }
  }, {
    key: "marcaOmitirCoincidencias",
    value: function marcaOmitirCoincidencias(idx) {
      var subp = this.subpregs[idx];
      subp.p.data.omit_history_match = !subp.p.data.omit_history_match;
      this.dirty = true;
    }
  }]);
}();
angular.module('candidato').component('tarjetaPregunta', {
  bindings: {
    pregunta: '<',
    pregsState: '<'
  },
  controller: TarjetaPreguntaComponentCtrl,
  template: require('./tarjeta-pregunta.component.html')
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/tarjeta-pregunta/tarjeta-pregunta.component.html"
});
angular.module('candidato').filter('substr', ["$sce", function ($sce) {
  function t(text) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    if (!text || text.length < n) return text || '';
    return text.substr(0, n) + '&mldr;';
  }
  return function (text) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    return $sce.trustAsHtml(t(text, n));
  };
}]);